import { render, staticRenderFns } from "./TableV1.vue?vue&type=template&id=630bfba6&"
import script from "./TableV1.vue?vue&type=script&lang=js&"
export * from "./TableV1.vue?vue&type=script&lang=js&"
import style0 from "./TableV1.vue?vue&type=style&index=0&id=630bfba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports